import PropTypes from 'prop-types'
import FormLabel from '@mui/material/FormLabel'
import { Slider, Rail, Handles, Tracks, Ticks } from 'react-compound-slider'
import {
  MuiRail,
  MuiHandle,
  MuiTrack,
  MuiTick,
} from '../MuiSliderHelper/MuiSliderHelper'
import { SliderContainer, SliderLabel } from './SliderStyles'

const SliderInput = ({
  sliderLabel,
  domain,
  initialValues,
  step,
  width,
  onChange,
  format,
  formatHandle,
  tickCount,
  tickValues,
  mode,
}) => {
  return (
    <>
      <SliderLabel htmlFor="sqft-slider">{sliderLabel}</SliderLabel>
      <SliderContainer>
        <Slider
          mode={mode}
          step={step}
          domain={domain}
          rootStyle={{
            position: 'absolute',
            width: width ? width : '80%',
            top: 30,
          }}
          onChange={(values) => onChange(values)}
          values={initialValues}
        >
          <Rail>
            {({ getRailProps }) => <MuiRail getRailProps={getRailProps} />}
          </Rail>
          <Handles>
            {({ handles, getHandleProps }) => (
              <div className="slider-handles">
                {handles.map((handle) => (
                  <MuiHandle
                    key={handle.id}
                    handle={handle}
                    formatHandle={formatHandle}
                    domain={domain}
                    getHandleProps={getHandleProps}
                  />
                ))}
              </div>
            )}
          </Handles>
          <Tracks left={false} right={false}>
            {({ tracks, getTrackProps }) => (
              <div className="slider-tracks">
                {tracks.map(({ id, source, target }) => (
                  <MuiTrack
                    key={id}
                    source={source}
                    target={target}
                    getTrackProps={getTrackProps}
                  />
                ))}
              </div>
            )}
          </Tracks>
          <Ticks count={tickCount} values={tickValues}>
            {({ ticks }) => (
              <div className="slider-ticks">
                {ticks.map((tick, idx) => (
                  <MuiTick
                    idx={idx}
                    key={tick.id}
                    tick={tick}
                    count={ticks.length}
                    format={format}
                  />
                ))}
              </div>
            )}
          </Ticks>
        </Slider>
      </SliderContainer>
    </>
  )
}

SliderInput.propTypes = {
  step: PropTypes.number,
  sliderLabel: PropTypes.string.isRequired,
  domain: PropTypes.arrayOf(PropTypes.any).isRequired,
  initialValues: PropTypes.arrayOf(PropTypes.any).isRequired,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  format: PropTypes.func,
  formatHandle: PropTypes.func,
  tickCount: PropTypes.number,
  tickValues: PropTypes.arrayOf(PropTypes.number),
}

SliderInput.defaulProps = {
  onChange: () => {},
  onUpdate: () => {},
  tickCount: 4,
  tickValues: null,
  step: 1,
}

export default SliderInput
